import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Regaster() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  const [user, setUser] = useState({
    username: '',
    email: '',
    password: '',
    name: '',
    role: '',
  });

  function getUserData(eventInfo) {
    let myUser = { ...user };
    myUser[eventInfo.target.name] = eventInfo.target.value;
    setUser(myUser);
  }

  async function sendRegisterDataToApi() {
    try {
      setIsLoading(true);
      setError('');

      let { data } = await axios.post(
        `https://e-commerce-api-kmhw.vercel.app/api/register`,
        user
      );

      if (data.token) {
        navigate('/login');
        console.log('Registration successful:', data);
      } else {
        setError(data.message || 'Registration failed');
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.message || 'An error occurred');
      } else {
        setError('Network error. Please try again.');
      }
      console.error('Registration error:', error);
    } finally {
      setIsLoading(false);
    }
  }

  function submitRegisterForm(e) {
    e.preventDefault();
    if (!user.username || !user.email || !user.password || !user.name || !user.role) {
      setError('Please fill all fields');
      return;
    }
    sendRegisterDataToApi();
  }

  return (
    <section
      className="d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: 'rgb(238, 238, 238)', // لون الخلفية
        minHeight: '100vh', // يغطي ارتفاع الشاشة
        width: '100%',
        padding: '40px 15px',
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <div className="card text-black shadow-lg" style={{ borderRadius: '20px' }}>
              <div className="card-body p-4 p-md-5">
                <div className="row g-4 align-items-center">

                  {/* نموذج التسجيل */}
                  <div className="col-12 col-md-6 order-2 order-md-1">
                    <p className="text-center h2 fw-bold mb-4">Sign up</p>
                    {error.length > 0 && (
                      <div className="alert alert-danger my-2">{error}</div>
                    )}

                    <form onSubmit={submitRegisterForm}>
                      <div className="mb-3">
                        <input
                          type="text"
                          id="username"
                          name="username"
                          className="form-control"
                          onChange={getUserData}
                          placeholder="Username"
                        />
                      </div>

                      <div className="mb-3">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          onChange={getUserData}
                          placeholder="Your Email"
                        />
                      </div>

                      <div className="mb-3">
                        <input
                          type="password"
                          id="password"
                          name="password"
                          className="form-control"
                          onChange={getUserData}
                          placeholder="Password"
                        />
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          onChange={getUserData}
                          placeholder="Name"
                        />
                      </div>

                      <div className="mb-4">
                        <select
                          id="role"
                          name="role"
                          className="form-select"
                          onChange={getUserData}
                        >
                          <option value="">Select Role</option>
                          <option value="user">User</option>
                          <option value="admin">Admin</option>
                        </select>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-2"
                        disabled={isLoading}
                      >
                        {isLoading ? <i className="fas fa-spinner fa-spin"></i> : 'Register'}
                      </button>
                    </form>
                  </div>

                  {/* الصورة */}
                  <div className="col-12 col-md-6 order-1 order-md-2 text-center">
                    <img
                      src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
                      className="img-fluid"
                      alt="Register"
                      style={{ maxHeight: '350px', objectFit: 'contain' }}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
